module.exports = __webpack_public_path__ + "img/icon-floating-top.2228ac66.svg";